import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {ProductsSvc} from '../../dashboard/services';
import {UserSvc} from './user.service';
import {forkJoin, from, Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable()
export class DashboardResolverService implements Resolve<any> {

  constructor(public productSvc: ProductsSvc, public userSvc: UserSvc) { }

  public resolve(): Observable<boolean> {
    return forkJoin({
      user: from(this.userSvc.getUser()),
      totalVCSProducts: this.productSvc.getCountVCSProducts()
    }).pipe(
      map(({user, totalVCSProducts}) => {
        return !user.hasSeenVCSProduct && totalVCSProducts > 0;
      })
    );
  }
}
